module.exports = __webpack_public_path__ + "winner-badge-team-4.caf1a67f098d6a3afcd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/winner-badge-team-4.svg
// module id = ./src/assets/svgs/winner-badge-team-4.svg
// module chunks = main